module.exports = __webpack_public_path__ + "static/img/ios_icon.5e89132.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/ios_icon.png
// module id = lLqd
// module chunks = 1